import { post, get, postData } from './http'
import global from '@/api/global'
var name = global.lj
// 队列设置
export const queueSettingsList = p => post(name + '/base/queueSettingsList', p)// 列表
export const queueSettinsAdd = p => post(name + '/base/queueSettingsAdd', p)// 新增
export const queueSettingsUpdate = p => post(name + '/base/queueSettingsUpdate', p)// 修改
export const queueSettingsDelete = p => post(name + '/base/queueSettingsDelete', p)// 删除
export const getDictionaryList = p => post(name + '/base/getDictionaryList', p)// 删除
export const getCallScreenList = p => post(name + '/factory/getCallScreenList', p)// 大屏

// 司机管理
export const driverVehicleList = p => post(name + '/base/driverVehicleList', p)// 列表

// 登记设置
export const getRegistrationSetting = p => post(name + '/base/getRegistrationSetting', p)// 列表
export const editRegistrationSetting = p => post(name + '/base/editRegistrationSetting', p)// 添加/编辑
export const tmsList = p => post(name + '/fence/tmsList', p)// 围栏列表
export const getPoundDifference = p => post(name + '/base/getPoundDifference', p)// 磅差页面查询
export const editPoundDifference = p => post(name + '/base/editPoundDifference', p)// 磅差设置添加/编辑
export const getLineUp = p => post(name + '/base/getLineUp', p)// 排队设置查询
export const editLineUp = p => post(name + '/base/editLineUp', p)// 排队设置添加/编辑
// 进仓登记
export const getQueueSettingsList = p => post(name + '/factory/getQueueSettingsList', p)
export const getJobStatusList = p => post(name + '/factory/getJobStatusList', p)
export const getSchedulingAssignmentList = p => post(name + '/factory/getSchedulingAssignmentList', p)
export const searchPhoneNumber = (p) => post(name + '/driver/listByAccount', p)
export const register = (p) => post(name + '/scheduling/vehicleRegisterPC', p)

// 排队叫号
export const getLlamadaQueueSettingsList = p => post(name + '/factory/getLlamadaQueueSettingsList', p)// 队列列表
export const operacionStopLlamar = p => post(name + '/factory/operacionStopLlamar', p)// 队列列表-停止叫号
export const operacionLlamar = p => post(name + '/factory/operacionLlamar', p)// 队列列表-叫号
export const getHacerColaList = p => post(name + '/factory/getHacerColaList', p)// 排队列表
export const getJumpQueueList = p => post(name + '/factory/getJumpQueueList', p)// 排队列表-插队列表
export const operacionJumpQueue = p => post(name + '/factory/operacionJumpQueue', p)// 排队列表-插队
export const getExFactoryList = p => post(name + '/factory/getExFactoryList', p)// 出厂管理列表
export const operateSpecialTreatment = p => post(name + '/factory/operateSpecialTreatment', p)// 出厂管理列表
export const getHistoryList = p => post(name + '/factory/getHistoryList', p)// 进出历史列表

// 地理围栏
export const fenceList = (p) => post(`${name}/fence/tmsList`, p)
export const fenceAdd = (p) => post(`${name}/fence/add`, p)
export const fenceDelete = (p) => post(`${name}/fence/delete`, p)
export const fenceUpdate = (p) => post(`${name}/fence/update`, p)
export const updateFence = (p) => post(`${name}/fence/updateFence`, p)

// 排队设置
export const queueSetting = (p) => post(`${name}/fence/tmsList`, p)
// 新增司机
export const addDriver = (p) => post(`${name}/base/addDriver`, p)
export const addPcDriverVehicle = (p) => post(`${name}/base/addPcDriverVehicle`, p)
export const getPcDriverVehicle = (p) => post(`${name}/base/getPcDriverVehicle`, p)
export const updateDriverVehicle = (p) => post(`${name}/base/updateDriverVehicle`, p)
export const deleteDriverVehicle = (p) => post(`${name}/base/deleteDriverVehicle`, p)
export const deleteDriver = (p) => post(`${name}/base/deleteDriver`, p)
export const deleteSchedulingAssignment = (p) => post(`${name}/factory/deleteSchedulingAssignment`, p)
export const detail = (p) => post(`${name}/scheduling/detail`, p)
export const updateSchedulingAssignment = (p) => post(`${name}/factory/updateSchedulingAssignment`, p)
// 进仓登记创建计划之后更新仓位信息
export const schedulingUpdateWarehouse = (p) => post(`${name}/scheduling/updateWarehouse`, p)
// 进出历史作业履历
export const getInstockInfo = (p) => post(`${name}/factory/getInstockInfo`, p)// 获取入库信息
export const getOutstockInfo = (p) => post(`${name}/factory/getOutstockInfo`, p)// 获取出库信息
export const findFlieUrl = (p) => post(`${name}/scheduling/findFlieUrl`, p)
// 订单管理
export const findPlanOrderList = (p) => post(`${name}/planOrder/findPlanOrderList`, p) // 查询
export const addPlanOrder = (p) => post(`${name}/planOrder/addPlanOrder`, p)// 新增
export const updatePlanOrder = (p) => post(`${name}/planOrder/updatePlanOrder`, p)// 修改
export const deletePlanOrder = (p) => post(`${name}/planOrder/deletePlanOrder`, p)// 删除
export const enablePlanOrder = (p) => post(`${name}/planOrder/enablePlanOrder`, p)// 停/启用
// 查看装卸凭证
export const findFlieUnloadUrl = (p) => post(`${name}/factory/findFlieUnloadUrl`, p)
// 获取外部订单号、收货单位等信息
export const findCfOrderPc = (p) => post(`${name}/api/findCfOrderPc`, p)
// 进仓登记修改
export const updateSa = (p) => post(`${name}/scheduling/updateSa`, p)
// 查询计划订单的排号信息
export const findSaForPlanList = (p) => post(`${name}/scheduling/findSaForPlanList`, p)
